import React from 'react'
import ReactDOM from 'react-dom'
import { SnackbarProvider } from 'notistack'
import { CookiesProvider } from 'react-cookie'
import { MuiThemeProvider } from '@material-ui/core'
import { MuiPickersUtilsProvider } from '@material-ui/pickers'
import MomentUtils from '@date-io/moment'
import moment from 'moment'

import App from './App'
import reportWebVitals from './reportWebVitals'
import { SessionProvider } from './contexts/SessionContext'
import theme from './theme/theme'

moment.locale('es-mx')

ReactDOM.render(
  <React.StrictMode>
    <SessionProvider>
      <CookiesProvider>
        <MuiPickersUtilsProvider utils={MomentUtils}>
          <MuiThemeProvider theme={theme}>
            <SnackbarProvider>
              <App />
            </SnackbarProvider>
          </MuiThemeProvider>
        </MuiPickersUtilsProvider>
      </CookiesProvider>
    </SessionProvider>
  </React.StrictMode>,
  document.getElementById('root')
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
